import SwapVertIcon from "@mui/icons-material/SwapVert";
import {
  Box,
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import React, { useEffect, useState } from "react";
import KenLoader from "../../GlobalComponents/KenLoader";
import { useToast } from "../../Helpers/Contexts/toastContext";
import { useAuthStore } from "../../store";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import {
  formatToIndianCurrencyWords2,
  mapHighestLevelToCategory,
  teamGradients,
} from "../../Utils/helperFunctions";
import { getPlayersDetails, getTeamDetails } from "../../Utils/apiService";
import { playerTeamLogo } from "../../Assets";
import AdminTeamSection from "./components/AdminTeamSection";

const commonCellStyles = {
  color: "#fff",
  fontSize: "14px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "normal",
  border: "none",
};

const AdminTeamDetails = () => {
  const { teamDetailsTrigger } = useAuthStore();
  const [loading, setLoading] = useState<boolean>(false);
  const [teamDetails, setTeamDetails] = useState<any>();
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  } | null>(null);
  const [step, setStep] = useState(1);
  const [selectedTeamIndex, setSelectedTeamIndex] = useState<number>(0);

  const fetchData = async () => {
    try {
      const [teamsRes] = await Promise.all([getTeamDetails()]);

      if (teamsRes?.data?.success) {
        setTeamDetails(teamsRes.data.data);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, [teamDetailsTrigger]);

  const team = teamDetails?.[selectedTeamIndex];

  const players = team?.Player_Registrations__r?.records || [];
  const getCategoryCount = (level: string) =>
    players.filter((p: any) => p.Recent_Competitive_Level__c === level).length;

  const remainingFundFormatted = formatToIndianCurrencyWords2(
    team?.Fund_Remaining__c
  );
  const totalFundFormatted = formatToIndianCurrencyWords2(team?.Total_Fund__c);
  const totalPlayers = players.length;

  const teamMeta = [
    { label: "Coach", value: "Sangalp N" },
    { label: "Owner", value: "Ram Jay" },
    { label: "Captain", value: "Sidharth D" },
  ];

  return loading ? (
    <KenLoader />
  ) : (
    <Box
      bgcolor=""
      color="#fff"
      padding={{ md: "20px", lg: "50px" }}
      sx={{
        // padding: "50px 50px",
        overflow: "hidden",
      }}
    >
      {step === 1 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <AdminTeamSection
            teamDetails={teamDetails}
            setStep={setStep}
            setSelectedTeamIndex={setSelectedTeamIndex}
          />
        </Box>
      ) : (
        <>
          {" "}
          <Button
            style={{
              textDecoration: "none",
              color: "#fff",
              fontSize: "18px",
              display: "flex",
              gap: 1,
              padding: "0 0 20px",
            }}
            onClick={() => {
              setStep(1);
            }}
          >
            <ArrowBackOutlinedIcon />
            Go Back
          </Button>
          <Box
            sx={{
              display: "flex",

              gap: "20px",
              marginBottom: "20px",
              overflowX: "auto",
              paddingBottom: "30px",
            }}
          >
            {teamDetails?.map((team: any, i: number) => {
              return (
                <Box
                  key={i}
                  onClick={() => setSelectedTeamIndex(i)}
                  sx={{
                    flex: 1,
                    textAlign: "center",
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: "5vw",
                  }}
                >
                  <Box
                    sx={{
                      width: "100px",
                      height: "100px",
                      background: "#ffffff80",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "10px",
                      borderRadius: "8px",
                      border:
                        selectedTeamIndex === i ? "2px solid #fff" : "none",
                    }}
                  >
                    <img
                      src={
                        team?.Name == "Aakash Tigers MWS"
                          ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
                          : team?.Name == "MSC Maratha Royals"
                          ? "https://mcadirectory.blob.core.windows.net/dev/4441894866960012-shivajiParkLions.png"
                          : team?.Name == "Triumph Knights Mumbai North East"
                          ? "https://mcadirectory.blob.core.windows.net/dev/007792959990218895-triumphKnights.png"
                          : team?.Logo_URL__c || playerTeamLogo
                      }
                      alt="Team Logo"
                      width={100}
                      height={100}
                      style={{
                        position: "relative",
                        zIndex: "10",
                        height: "100%",
                        width: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
          <Box
            flexWrap={{ xs: "wrap", lg: "nowrap" }}
            sx={{
              borderRadius: "12px",
              background: "rgba(0, 0, 0, 0.34)",
              backdropFilter: "blur(5px)",
              justifyContent: "space-between",
              display: "flex",

              marginBottom: "40px",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                height: "200px",
                width: "200px",
                padding: "20px",
                flex: "20%",
              }}
            >
              <img
                src={
                  team?.Name == "Aakash Tigers MWS"
                    ? "https://turbostart.blob.core.windows.net/turbostart/48447191083078844-aakashTigers.png"
                    : team?.Name == "MSC Maratha Royals"
                    ? "https://mcadirectory.blob.core.windows.net/dev/4441894866960012-shivajiParkLions.png"
                    : team?.Logo_URL__c || playerTeamLogo
                }
                style={{ objectFit: "contain", width: "100%", height: "100%" }}
                alt="logo"
              />
            </Box>
            <Box
              sx={{
                flex: "50%",
                display: "flex",
                gap: "20px",
                justifyContent: "center",
              }}
            >
              {/* <Box
                sx={{
                  width: "fit-content",
                  color: "#fff",
                  borderLeft: "0.5px solid #EAEAEA",
                  background:
                    "linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)",
                }}
              >
                {teamMeta.map((meta, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                      padding: "0.7vw 1vw",
                      borderBottom:
                        index !== teamMeta.length - 1
                          ? "1px solid rgba(255, 255, 255, 0.15)"
                          : "none",
                      pr: 4,
                    }}
                  >
                    <Typography
                      sx={{ color: "#E07E27", fontWeight: 600, width: "100px" }}
                    >
                      {meta.label}
                    </Typography>
                    <Typography sx={{ color: "white", fontWeight: 300 }}>
                      –
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        color: "white",
                        whiteSpace: "nowrap",
                        marginLeft: "1vw",
                      }}
                    >
                      {meta.value}
                    </Typography>
                  </Box>
                ))}
              </Box> */}
              <Grid container spacing={"10px"} sx={{ width: "fit-content" }}>
                {[
                  {
                    label: "Icon",
                    count: getCategoryCount("Indian senior team"),
                    minPlayerCount: 1,
                  },
                  {
                    label: "Senior",
                    count: getCategoryCount(
                      "First class, list A, BCCI Senior Men T20"
                    ),
                    minPlayerCount: 4,
                  },
                  {
                    label: "Emerging",
                    count: getCategoryCount(
                      "Mumbai age group team (under 23 or under 19)"
                    ),
                    minPlayerCount: 5,
                  },
                  {
                    label: "Development",
                    count: getCategoryCount("Local club team"),
                    minPlayerCount: 5,
                  },
                ].map((item, index) => (
                  <Grid item xs={6} key={index}>
                    <Box
                      sx={{
                        padding: "20px",
                        minWidth: "100px",
                        // width: "fit-content",
                        color: "#fff",
                        borderLeft: "0.5px solid #EAEAEA",
                        background:
                          "linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)",
                      }}
                    >
                      <Typography
                        variant="h4"
                        sx={{
                          fontSize: "15px",
                          fontWeight: 500,
                          padding: " ",
                        }}
                        color="white"
                      >
                        {item.label} ({item.count}/{item.minPlayerCount})
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
            <Box
              sx={{
                padding: "40px 40px 40px 20px",
                display: "flex",
                flexDirection: "column",
                borderRadius: "0 12px 12px 0",
                textAlign: "center",
                color: "#ffffff80",
                height: "100%",
                flex: "20%",
                borderLeft: "0.5px solid #EAEAEA",
                background:
                  "linear-gradient(90deg, rgba(255, 255, 255, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)",
              }}
            >
              <Box
                sx={{
                  p: 1,
                }}
              >
                <Typography
                  variant="h2"
                  mb={2}
                  fontSize={{
                    xs: "24px",
                    md: "28px",
                    // lg: "36px",
                    // xl: "44px",
                  }}
                >
                  Total Players
                </Typography>
                <Typography
                  fontSize={{
                    xs: "24px",
                    md: "28px",
                    // lg: "36px",
                    // xl: "44px",
                  }}
                  variant="h4"
                  sx={{ fontWeight: 700 }}
                  color="white"
                >
                  {totalPlayers}/18
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                padding: "40px 40px 40px 20px",
                display: "flex",
                flexDirection: "column",
                background: "rgba(255, 255, 255, 0.10)",
                borderRadius: "0 12px 12px 0",
                color: "#ffffff80",
                height: "100%",
                flex: "20%",
              }}
            >
              {[
                {
                  label: "Team purse",
                  value: totalFundFormatted,
                },
                {
                  label: "Fund remaining",
                  value: remainingFundFormatted,
                },
                // {
                //   label: "Funds remaining for bidding",
                //   value: "₹75 L",
                // },
              ].map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    borderBottom: idx < 1 ? "1px solid #ffffff20" : "none",
                    p: 1,
                  }}
                >
                  <Typography
                    variant="h2"
                    fontSize={{
                      xs: "24px",
                      md: "28px",
                      lg: "36px",
                      xl: "44px",
                    }}
                  >
                    {item.value}
                  </Typography>
                  <Typography variant="h2" sx={{ fontSize: 12 }}>
                    {item.label}
                  </Typography>
                </Box>
              ))}
              {/* <Box sx={{ borderBottom: "1px solid #ffffff20", padding: "10px" }}>
            <Typography variant="h2">{totalFundFormatted}</Typography>
            <Typography variant="h2" sx={{ fontSize: "12px" }}>
              Team purse
            </Typography>
          </Box>
          <Box sx={{ borderBottom: "1px solid #ffffff20", padding: "10px" }}>
            <Typography variant="h2" sx={{ fontSize: "44px" }}>
              {remainingFundFormatted}
            </Typography>
            <Typography variant="h2" sx={{ fontSize: "12px" }}>
              Fund remaining
            </Typography>
          </Box>
          <Box sx={{ padding: "10px" }}>
            <Typography variant="h2" sx={{ fontSize: "44px" }}>
              ₹75 L
            </Typography>
            <Typography variant="h2" sx={{ fontSize: "12px" }}>
              Funds remaining for bidding
            </Typography>
          </Box> */}
            </Box>
          </Box>
          <TableContainer
            component={Paper}
            sx={{
              backgroundColor: "#16161699",
              border: "1px solid #FFFFFF33",
              marginBottom: "20px",
            }}
          >
            <Table>
              <TableHead sx={{ background: "#1C2C66" }}>
                <TableRow sx={{ borderBottom: "1px solid #FFFFFF33" }}>
                  {[
                    { label: "SI.No" },
                    { label: "Name of the player", sortKey: "name" },
                    // { label: "MCA ID", sortKey: "MCANo" },
                    { label: "Category" },
                    { label: "Role" },
                    // { label: "Runs" },
                    // { label: "Matches" },
                    // { label: "Wickets" },
                    { label: "Base price" },

                    { label: "Purchased price" },
                  ].map(({ label, sortKey }, idx) => {
                    const isActive = sortKey && sortConfig?.key === sortKey;
                    const isSortable = Boolean(sortKey);
                    const direction = isActive ? sortConfig?.direction : "asc";
                    return (
                      <TableCell
                        key={idx}
                        sx={{
                          color: "#fff",
                          border: "none",
                          fontWeight: "600",
                          fontSize: "16px",
                          cursor: isSortable ? "pointer" : "default",
                          userSelect: "none",
                        }}
                        onClick={() => {
                          if (!sortKey) return;
                          setSortConfig((prev) =>
                            prev?.key === sortKey
                              ? {
                                  key: sortKey,
                                  direction:
                                    prev.direction === "asc" ? "desc" : "asc",
                                }
                              : { key: sortKey, direction: "asc" }
                          );
                        }}
                      >
                        <Box display="flex" alignItems="center" gap="4px">
                          {label}
                          {isSortable && (
                            <span
                              style={{
                                fontSize: "14px",
                                opacity: isActive ? 1 : 0.5,
                              }}
                            >
                              {direction === "asc" ? (
                                <SwapVertIcon />
                              ) : (
                                <SwapVertIcon />
                              )}
                            </span>
                          )}
                        </Box>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {team?.Player_Registrations__r?.records.map(
                  (player: any, index: number) => {
                    return (
                      <TableRow
                        key={player.playerId}
                        sx={{ borderBottom: "1px solid #FFFFFF33" }}
                      >
                        <TableCell sx={commonCellStyles}>
                          {/* {player?.auctionNumber ?? "--"}. */}
                          {index + 1}.
                        </TableCell>
                        <TableCell sx={commonCellStyles}>
                          {player.Player__r?.Name}
                        </TableCell>
                        {/* <TableCell sx={commonCellStyles}>
                          {player?.Player__r?.MCA_Registration_Number__c}
                        </TableCell> */}

                        {/* <TableCell sx={commonCellStyles}>
                      {runs ?? "-"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {matches ?? "-"}
                    </TableCell>
                    <TableCell sx={commonCellStyles}>
                      {wickets ?? "-"}
                    </TableCell> */}
                        <TableCell sx={commonCellStyles}>
                          {mapHighestLevelToCategory(
                            player?.Recent_Competitive_Level__c
                          )}
                        </TableCell>
                        <TableCell sx={commonCellStyles}>
                          {player.Primary_Role__c}
                        </TableCell>
                        <TableCell sx={commonCellStyles}>
                          {player?.Base_Price__c != null
                            ? `₹${player.Base_Price__c.toLocaleString("en-IN")}`
                            : "--"}
                        </TableCell>

                        <TableCell sx={commonCellStyles}>
                          {player?.Winning_Bid__c != null
                            ? `₹${player.Winning_Bid__c.toLocaleString(
                                "en-IN"
                              )}`
                            : "--"}
                        </TableCell>
                      </TableRow>
                    );
                  }
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Box>
  );
};

export default AdminTeamDetails;
